import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

const RedirectRoot = ({ path }) => <Redirect to={path} />;

RedirectRoot.propTypes = {
  path: PropTypes.string.isRequired,
};

export default RedirectRoot;
